import DraftBaseController from 'cio/pods/draft/base-controller';

export default class PreviewController extends DraftBaseController {}
